var _path, _mask, _circle, _mask2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIcNotes1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.393 5.874a5.375 5.375 0 1 1 10.75.036v.061c-.037 1.93-1.115 3.713-2.436 5.107a14.127 14.127 0 0 1-2.514 2.07.651.651 0 0 1-.852 0 13.872 13.872 0 0 1-3.536-3.312 6.878 6.878 0 0 1-1.412-3.944v-.018z",
    fill: "url(#aa)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "b",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 0,
    width: 12,
    height: 14
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.393 5.874a5.375 5.375 0 1 1 10.75.036v.061c-.037 1.93-1.115 3.713-2.436 5.107a14.127 14.127 0 0 1-2.514 2.07.651.651 0 0 1-.852 0 13.872 13.872 0 0 1-3.536-3.312 6.878 6.878 0 0 1-1.412-3.944v-.018z",
    fill: "#fff"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6.7,
    cy: 5.977,
    fill: "url(#dd)",
    r: 1.723
  })), _mask2 || (_mask2 = /*#__PURE__*/React.createElement("mask", {
    id: "e",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 4,
    width: 4,
    height: 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6.767,
    cy: 5.977,
    fill: "#fff",
    r: 1.723
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "aa",
    x1: 1.393,
    y1: 0.517,
    x2: 1.393,
    y2: 13.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDE9FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7D9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dd",
    x1: 5.044,
    y1: 4.255,
    x2: 5.044,
    y2: 7.7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0084E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#004CC4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIcNotes1);
export default __webpack_public_path__ + "static/media/icon-ic-notes1.0260286b.svg";
export { ForwardRef as ReactComponent };